import React, { useState, useEffect } from 'react'
import useModal from 'hook/useModal'

// css
import 'assets/style/elements/input-comment.scss'

import TextInput from 'components/elements/TextInput'
import IconButton from 'components/elements/IconButton'

function Element({ value, className, placeholder = '입력하세요.', disabled = false }) {
  // if ([true, 'true'].includes(disabled)) {
  //   disabled = true;
  // }
  return (
    <>
      <input
        type="text"
        className={'input-comment ' + className}
        defaultValue={value}
        placeholder={'댓글을 입력해주세요'}
        disabled={disabled}
      />
      <div className="reply-form flex">
        <TextInput placeholder="답글을 입력하세요." />
        <IconButton type="write" size="20" />
      </div>
    </>
  )
}

export default Element
